/**
 * Filter used to create a number with two Digits
 * @param data
 * @returns {string}
 */
export default function (data) {
  return data !== undefined && !isNaN(data) ? ('0' + data).slice(-2) : null
}
